import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators,AbstractControl, FormArray } from '@angular/forms';
import { Invoice } from 'app/shared/types/invoice';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ReceiptService } from 'app/shared/services/receipt.service';
import { QuotationService } from 'app/shared/services/quotation.service';
import { ItemService } from 'app/shared/services/item.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';

@Component({
  selector: 'ngx-bar-invoice',
  templateUrl: './bar-invoice.component.html',
  styleUrls: ['./bar-invoice.component.scss']
})
export class BarInvoiceComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;

  paymentType:string=null;;
  depositAccount:string=null;
  isPaidChecked = false;
  bankAccountList : any[];


   crud_access = {
     read: null,
     create: null,
     approve: null,
     delete: null,
     createReceipt:null,
    };

  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredCustomerList: Observable<any[]>;
  customerList : any[];
  warehouseList: any[];
  salesRepList: any[];
  invoice:Invoice;
  invoiceData = [];
  stockData = [];
  receiptData = [];
  receiptNo : string  = null;
  invoiceForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isfieldReceivedReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isHideBtn: boolean= false;
  isShowAttachBtn: boolean=false;
  isShowPayBtn: boolean=false;
  isCancelBtnDisabled : boolean= false;
  showInvoicePmtDetails : boolean= false;
  bsClassToShow : boolean = false;
  isEditDiscRate : boolean = false;
  selectChkBox : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  panelTitle ="Invoice";
  companyData : any  = [];
  logo :any;

  PMT_TYPE =[
    {value: 'Cash'},
    {value: 'Cheque'},
    {value: 'Card Payment'},
    {value: 'Bank Transfer'},

  ];


  validationMessages = {
    'invoiceNo': { 'required': 'Invoice number is required' },
    'invoiceDate': { 'required': 'Invoice date is required' },
    'cusId': {'required': 'Guest Id is required' },  
    'cusName': {'required': 'Guest name is required' },
  };

  formErrors = {
    'invoiceNo': "",
    'invoiceDate': "",
    'cusId':"",
    'cusName': "",
  };


  constructor(private fb: FormBuilder,
        private invoiceService: InvoiceService,
        private fileUploadService:FileUploadService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private itemService : ItemService,
        private route : ActivatedRoute,
        private router : Router, 
        private customerService : CustomerService,
        private bankAccountsService: BankAccountsService,
        private receiptService :ReceiptService,
        private decimalPipe: DecimalPipe,
        private companyProfileService: CompanyProfileService,
        private themeService: NbThemeService )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });
      }

  ngOnInit() {
 
      this.initInvoceType();
      this.initFormFields();
      this.getCompanyDetails();
      this.getBankAccountList();
      this.getItemList();

      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;
      this.disableForm();
   
      this.getCustomerList();
      this.viewInvoiceById();
      this.getControlPermissions();
  
      this.autoCompleteCustomer();

      this.invoiceForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.invoiceForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  getControlPermissions(){
    var data = [];
    var data2 = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='BAR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }

    data2 =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
    if(data2.length > 0){
      this.crud_access.createReceipt = data2[0].create;

    }

  }

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }


    

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;   
                this.loadLogo();         

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }
  
 
  autoComplete(index: number){
    this.filteredOptions[index] =this.getInvoiceItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteCustomer(){
      this.filteredCustomerList = this.invoiceForm.get('cusName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.GuestName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(i){
    var filteredData;
    var value  = this.getInvoiceItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
      this.getInvoiceItems.at(i).patchValue({ 
        description : filteredData[0].Description,
        salesType : filteredData[0].Category,
        unitCost : filteredData[0].UnitCost,
        unitPrice:  filteredData[0].UnitPrice,
        qty :'1.00', 
        discount: '',
        amount : filteredData[0].UnitPrice,
      });    
    }else{
      this.getInvoiceItems.at(i).patchValue({ 
        description : '',
        salesType : '',
        unitCost : '',
        unitPrice:  '',
        qty: '',
        discount: '',
        amount : '',
      });     

    }
  }
}



getCustomerDetails(){      
  var filteredData;
  var cusName = this.invoiceForm.value.cusName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.GuestName.toLowerCase()===cusName.toLowerCase());
   if(filteredData.length ===1){
     this.invoiceForm.patchValue({
       cusId : filteredData[0].GuestId,
       address :filteredData[0].Address,
     });
   }else{
    this.invoiceForm.patchValue({
      cusId : null,
      address :null,
    });
   }
  }
}
     

  
getItemList(){
  this.itemService.getAll()
     .subscribe(
        (data) => {
                  this.itemList = data.filter((el)=>{
                    return el.Category ==="Bar Item";
                  });  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
 }

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }

   getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {  
                  this.bankAccountList = data           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }


  initInvoceType() : void{

    this.invoice = {
      id : null,
      invoiceNo: '',
      invoiceDate: '',
      cusId: '',
      cusName: '',
      address: '',
      country:  '',
      email:  '',
      phone:  '',
      nic:  '',
      checkIn:  '',
      checkOut:  '',
      roomType:  '',
      roomNo:  '',

     
      itemCode: '',
      description: '',
      salesType: '',
      unitPrice:  0.00,
      qty:  0.00,
      discount:  0.00,
      commission:  0.00,
      amount:  0.00,

      totalQty: 0.00,
      totalDiscount: 0.00,
      totalComm: 0.00,
      subTotal: 0.00,   
      vat: 0.00,
      grandTotal: 0.00,
      totalCost: 0.00,
      totalProfit: 0.00,
      balToPay: 0.00,
      advancePaid: 0.00,
      amountPaid: 0.00, 

      remarks : '',
      status : '',
      type : '',
      createdBy : '',

    };

    this.paymentType=null;;
    this.depositAccount=null;
  }


  initFormFields() : void{
    this.invoiceForm = this.fb.group({
      id : [null],
      invoiceNo : ['',Validators.required],
      invoiceDate : ['',Validators.required],
      cusId : ['',Validators.required],
      cusName : [null,Validators.required],
      address : [''],
      invoiceItems : this.fb.array([this.addInvoiceItem()]), 
       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.selectChkBox= false;
    this.isBtnDisabled = false;
    this.isHideBtn = false;
    this.isShowAttachBtn=false;
    this.isShowPayBtn=false;
    this.isCancelBtnDisabled = true;
    this.invoiceForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getMaxId();
    this.addItemButtonClick();
    this.invoiceForm.patchValue({
      invoiceDate:  this.defaultDate
    });
     
   }

   getMaxId(){
    var invoiceNo = 0;
    var invNoPrefixZero  : String;
  
    this.invoiceService.getBarMaxId()
    .subscribe(
      (res) => {
          invoiceNo = Number(res[0].InvoiceNo) + 1;
          invNoPrefixZero = invoiceNo.toString().padStart(4,'0');       
          this.invoiceForm.patchValue({
            invoiceNo : "BIN" + invNoPrefixZero
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }

   getMaxReceiptId(){
    var receiptNo = 0;
    var receiptNoPrefixZero  : String;
  
    this.receiptService.getMaxId()
    .subscribe(
      (res) => {
          receiptNo = Number(res[0].ReceiptNo) + 1;
          receiptNoPrefixZero = receiptNo.toString().padStart(6,'0');               
          this.receiptNo = "CPMT" + receiptNoPrefixZero;
        
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }, 
      )

   }
  
  
   addInvoiceItem() : FormGroup{  
    return this.fb.group({
     itemCode : ['',Validators.required],
     description : ['',Validators.required],
     salesType : [''],
     unitCost : [''],
     unitPrice :['',Validators.required],
     qty : ['',Validators.required],  
     discount :[''],
     commission : [''],  
     amount : ['',Validators.required],    

    });
   
  }


   get getInvoiceItems(){
      return this.invoiceForm.get('invoiceItems') as FormArray;
   }


   receivedFieldFocusOut(){
    if(this.invoice.amountPaid==0){
      this.selectChkBox = false;
      this.isPaidChecked = false;
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly = true;
      this.receiptNo = null;
    }

    this.updateBillTotal();

   }

   selectReceivedAmountCheckBoxChange(event){
    if(event.checked){
      this.isPaidChecked = true
      this.getMaxReceiptId();
      this.isfieldReceivedReadOnly  = false;
      this.invoice.amountPaid = this.invoice.grandTotal;     
    }
    else{
      this.isPaidChecked = false;
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly  = true;
      this.receiptNo = null;
    }

    this.updateBillTotal();

  }

   addItemButtonClick() : void {
          this.getInvoiceItems.push(this.addInvoiceItem());
          this.autoComplete(this.getInvoiceItems.length-1);    
         // this.calculateDiscount();
          this.selectChkBox = false;
          this.isPaidChecked = false;
          this.invoice.amountPaid = 0.00;
          this.isfieldReceivedReadOnly  = true;
          this.receiptNo = null;
          this.updateBillTotal();    
  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getInvoiceItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
     // this.calculateDiscount();
      this.selectChkBox = false;
      this.invoice.amountPaid = 0.00;
      this.isfieldReceivedReadOnly  = true;
      this.receiptNo = null;
      this.updateBillTotal();

    }

    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }

        this.invoice.totalQty= 0.00;
        this.invoice.totalDiscount= 0.00;
        this.invoice.subTotal = 0.00;
        this.invoice.vat = 0.00;
        this.invoice.grandTotal = 0.00;
        this.invoice.totalCost= 0.00;
        this.invoice.totalProfit= 0.00;
        this.invoice.amountPaid = 0.00;
        this.invoice.balToPay = 0.00;
        this.receiptNo = null;
        this.showInvoicePmtDetails = false;
        this.bsClassToShow = false;

        this.paymentType=null;;
        this.depositAccount=null;
       
    }


  
    calEachItemAmount(i){
      var unitPrice : number;
      let discount :  number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getInvoiceItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.getInvoiceItems.at(i).get('unitPrice').value ? parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value) :0;
      qty = this.getInvoiceItems.at(i).get('qty').value ?  parseFloat(this.getInvoiceItems.at(i).get('qty').value) : 0;
      amount = parseFloat((unitPrice * qty).toFixed(2));

      discount = this.getInvoiceItems.at(i).get('discount').value ? parseFloat(this.getInvoiceItems.at(i).get('discount').value) :0;

      amount = (unitPrice * qty)- discount;

      this.getInvoiceItems.at(i).patchValue({amount : amount.toString() });


      }
  
      this.updateBillTotal();
    }


  updateBillTotal(){
    this.invoice.totalQty = +this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.qty, 0);
    this.invoice.totalDiscount = +this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.discount, 0);
    this.invoice.subTotal = +this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
    this.invoice.vat = 0.00; 
    this.invoice.grandTotal =  this.invoice.subTotal;
    this.invoice.balToPay = +this.invoice.grandTotal - +this.invoice.amountPaid; 
  }




  mapFormValuesToModel(){
    this.invoiceData =[];
    this.stockData =[];
    this.receiptData =[];
    var resultInvoice = [];
    var resultReceipt = [];
   

    for(let i=0; i < this.getInvoiceItems.length; i++){

    this.invoice.invoiceNo=this.invoiceForm.value.invoiceNo;
    this.invoice.invoiceDate=this.invoiceForm.value.invoiceDate;
    this.invoice.cusId=this.invoiceForm.value.cusId;
    this.invoice.cusName=this.invoiceForm.value.cusName;
    this.invoice.address = this.invoiceForm.value.address;
  
    this.invoice.itemCode = this.getInvoiceItems.value[i].itemCode
    this.invoice.description=this.getInvoiceItems.value[i].description;
    this.invoice.salesType=this.getInvoiceItems.value[i].salesType;
    this.invoice.unitPrice=this.getInvoiceItems.value[i].unitPrice;
    this.invoice.qty=this.getInvoiceItems.value[i].qty;
    this.invoice.discount =this.getInvoiceItems.value[i].discount;
    this.invoice.amount=this.getInvoiceItems.value[i].amount;
    

    this.invoice.totalQty=this.invoice.totalQty;
    this.invoice.totalDiscount=this.invoice.totalDiscount;
    this.invoice.subTotal=this.invoice.subTotal;
    this.invoice.vat =this.invoice.vat
    this.invoice.grandTotal=this.invoice.grandTotal;
    this.invoice.totalCost = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +(curr.unitCost * curr.qty), 0);
    this.invoice.totalProfit=this.invoice.grandTotal - this.invoice.totalCost;
    this.invoice.balToPay= this.invoice.balToPay;
    this.invoice.amountPaid=this.invoice.amountPaid;

    this.invoice.remarks=this.invoice.remarks;


           if (this.invoice.amountPaid == 0)
            {
              this.invoice.status = "Unpaid";
            }
            else if (this.invoice.amountPaid == this.invoice.grandTotal)
            {
              this.invoice.status = "Paid";
            }
            else
            {
              this.invoice.status = "Partially paid";
            }

    this.invoice.type ="Bar Invoice";
    this.invoice.createdBy =this.authService.getUserLoggedIn();
    
    this.invoiceData.push(
      this.invoice.invoiceNo,
      this.invoice.invoiceDate,
      this.invoice.cusId,
      this.invoice.cusName,
      this.invoice.address, //5

      this.invoice.itemCode,
      this.invoice.description,
      this.invoice.salesType,
      this.invoice.unitPrice,
      this.invoice.qty,
      this.invoice.discount,
      this.invoice.amount,  //12

      this.invoice.totalQty,
      this.invoice.totalDiscount,
      this.invoice.subTotal,
      this.invoice.vat,
      this.invoice.grandTotal,
      this.invoice.totalCost,
      this.invoice.totalProfit,
      this.invoice.balToPay,
      this.invoice.amountPaid, //21
  
      this.invoice.remarks,
      this.invoice.status,
      this.invoice.type,
      this.invoice.createdBy,  //25

      );

    }

  if(this.receiptNo){

    this.receiptData.push(
      this.receiptNo,
      this.invoice.invoiceDate,
      this.paymentType,
      this.invoice.cusId,
      this.invoice.cusName,
      this.invoice.address,
      this.depositAccount,
      null,
      this.invoice.amountPaid,
      this.invoice.invoiceDate,
      this.invoice.invoiceNo,
      this.invoice.grandTotal,
      this.invoice.grandTotal,
      this.invoice.amountPaid,
      this.invoice.status,
      this.invoice.createdBy,     
      );

    }

    while(this.invoiceData.length){
      resultInvoice.push(this.invoiceData.splice(0,25));
    }
  
    while(this.receiptData.length){
      resultReceipt.push(this.receiptData.splice(0,16));
    }

   // return result;
   return [resultInvoice,resultReceipt];

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.invoiceForm,true);
 
    const [invoiceData,receiptData] = this.mapFormValuesToModel();
    const body = {invoiceData : invoiceData, receiptData : receiptData}

    console.log(body)

    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.invoiceService.addBarInvoice(body)
          .subscribe(
            (res) =>{               
                if(res.success === 0){
                  this.invoiceForm.patchValue({
                    invoiceNo : res.autoId
                  });
                this.saveButtonClick();
                this.showProcessingIndicator = false; 
              }else if(res.success === 1){
                this.toastr.success('Invoice created successfully','Success');
                this.isfieldReadOnly  = true;
                this.isBtnDisabled = true;
                this.isHideBtn = true;
                this.isShowAttachBtn = true;
                this.isCancelBtnDisabled = false;
                this.disableForm(); 
                this.showProcessingIndicator = false;   
              }   
                  
         
            },
            (err) =>{ 
              this.toastr.error('Failed to create invoice','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   deleteButtonClick(){   
    var invoiceNo = this.invoiceForm.get('invoiceNo').value;
    if(invoiceNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this invoice?')
    .afterClosed().subscribe(res =>{
      if(res){
  
        const [invoiceData,receiptData] = this.mapFormValuesToModel();
        const body = {invoiceData : invoiceData} 
     this.invoiceService.deleteInvoice(body,invoiceNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Invoice deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete invoice','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.invoiceForm.controls).forEach(key => {
      this.invoiceForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.invoiceForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.invoiceForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.invoiceForm.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.invoiceForm.value.cusId;
    if(!value){
      this.invoiceForm.patchValue({ cusId :  null,cusName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getInvoiceItems.length==0 || this.invoiceForm.get('invoiceItems').invalid){
            return false;
          }

        return true;
  }

 



    viewInvoiceById(){
        var hasInvoiceNo;
        var invoiceNo;

          hasInvoiceNo =this.route.snapshot.queryParamMap.has('invoiceNo');
         
          if(hasInvoiceNo){
            invoiceNo = this.route.snapshot.queryParamMap.get('invoiceNo')
            this.invoiceService.getInvoice(invoiceNo)
            .subscribe(
              (data) => {
                        if(data){                         
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;    
                          this.isHideBtn = true;                    
                          this.showInvoicePmtDetails = true;    
                          this.bsClassToShow = true;      
                          this.isShowAttachBtn = true;                  
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }

    }

patchValuesToForm(data){

  this.invoiceForm.patchValue({  
    invoiceNo : data[0].InvoiceNo,
    invoiceDate : moment(data[0].InvoiceDate).format("YYYY-MM-DD"),
    cusId : data[0].GuestId,
    cusName : data[0].GuestName,
    address : data[0].GuestAddress,

  });
  
  this.invoiceForm.setControl('invoiceItems',this.setInvoiceItems(data));


  this.invoice.totalQty= data[0].TotalQty;
  this.invoice.totalDiscount= data[0].TotalDiscount;
  this.invoice.subTotal= data[0].SubTotal;
  this.invoice.vat = data[0].Vat;
  this.invoice.grandTotal = data[0].GrandTotal,
  this.invoice.amountPaid = data[0].AmountPaid;
  this.invoice.balToPay = data[0].BalToPay;
  this.invoice.remarks = data[0].Remarks;
  this.invoice.status = data[0].Status;


  this.isShowPayBtn = true;
  if(data[0].Status==='Paid'){
    this.isCancelBtnDisabled = true;
    this.isShowPayBtn = false;
  }

}


  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode],
        description : [data[i].Description],
        salesType: [data[i].SalesType],
        unitCost : [''],
        unitPrice : [data[i].UnitPrice],
        qty : [data[i].Qty],
        discount : [data[i].Discount],
        amount : [data[i].Amount],  
       
      }));
    }
    return invoiceItemArray;
  }




attachFileButtonClick(){
 this.fileUploadService.refNo = this.invoiceForm.value.invoiceNo;
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = "75%";
   this.dialogService.openDialog(FileUploadComponent,dialogConfig)
   .afterClosed().subscribe(res => {
    //this.getAll()
   });  
 }

 payButtonClicked(){  
   var invoiceNo = this.invoiceForm.value.invoiceNo;
  this.router.navigate(['../receipt'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});            
 }


    savePDF(action){
     
      let invoiceNoBox = {type: 'rect',x: 0,  y: 0,  w: 120,  h: 30,lineColor: '#080808', r: 10};  
   
    const documentDefinition = { 
      pageSize: 'A4',
      pageOrientation: 'portrait',  
      pageMargins: [40, 40, 40, 120],
 
      content: [ 
          
        {
          columns : [ 
            
                  { image:this.logo,            
                    width: 120,
                    height: 120,
                  },                                                       
                  [
                    {
                      text: this.companyData[0].CompanyName,  
                      bold: true,
                      fontSize: 30,
                      alignment: 'right',
                    },
                    { text: this.companyData[0].Address,  alignment: 'right', },  
                    { text: this.companyData[0].Phone,  alignment: 'right', },  
                    { text: this.companyData[0].Email,  alignment: 'right', }  
                  ],   
           ]
   
        },   
        
        `\n`,
        `\n`,

        {
          table: {
            widths: ['auto', 'auto','*','auto','auto'], 
            headerRows: 1,
            body: [
              [{text:'Guest Name',margin: [5, 0, 0, 0]},{text: `: ${this.invoiceForm.value.cusName}`,margin: [5, 0, 0, 0]},{text:'',margin: [5, 0, 0, 0]},{text:'Invoice Date'},{text: `: ${this.invoiceForm.value.invoiceDate}`,margin: [5, 0, 0, 0]}],
              [{text:'Address',margin: [5, 0, 0, 0]},   {text:`: ${this.invoiceForm.value.address}`,margin: [5, 0, 0, 0]},{text:'',margin: [5, 0, 0, 0]},{text:'Invoice No',margin: [5, 0, 0, 0]},  {text:  `: ${this.invoiceForm.value.invoiceNo}`,margin: [5, 0, 0, 0]}],            ]
          },
          layout: 'noBorders'
        },
     
        '\n\n',
                           
        {  
          layout: {
            defaultBorder: false,
            hLineWidth: function(i, node) {
              return 1;
            },
            vLineWidth: function(i, node) {
              return 1;
            },
            hLineColor: function(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function(i, node) {
              return '#eaeaea';
            },
            hLineStyle: function(i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function(i, node) {
              return 10;
            },
            paddingRight: function(i, node) {
              return 10;
            },
            paddingTop: function(i, node) {
              return 2;
            },
            paddingBottom: function(i, node) {
              return 2;
            },
            fillColor: function(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {  
             
              headerRows: 1,  
              widths: ['auto', '*', 'auto','auto','auto', 'auto'],  
              body: [  
                [
                 { text: 'ItemCode', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Description', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'UnitPrice', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Qty', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Disc(%)', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                ...this.getInvoiceItems.value.map(p => ([{ text :p.itemCode, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},{ text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.qty), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.discount), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' }, { text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' }])),               
              ]           
        }       
      },

      '\n',
      '\n',
      {
        columns : [
                  {},
                       
              { 
                layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return '#eaeaea';
                },
                vLineColor: function(i, node) {
                  return '#eaeaea';
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return '#fff';
                },
              },
                width: 'auto', 
                fontSize: 12,            
                table: {
                headerRows: 1,
                widths: ['auto', 'auto'],
                    body: [
                    [
                      {
                        text: 'SubTotal',
                        bold: true,
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.grandTotal),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],
                    [
                      {
                        text: 'Total Discount',
                        bold: true,
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.totalDiscount),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],
                    [
                      {
                        text: 'GrandTotal',
                        bold: true,
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.invoice.grandTotal),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],
                  ],
                },
              },         
        ]

      },

      '\n',
      '\n\n',
      '\n\n',
      // {
      //   columns :
      //    [  [],
      //      [        
      //       {text: 'INVOICE NO',alignment: 'center', bold: true, margin: [0, 0, 0, 5]},         
      //       {canvas: [invoiceNoBox],alignment:'center'},
      //         {
      //           columns : [
      //             {alignment:'center',width : invoiceNoBox.w, noWrap:false,maxHeight :invoiceNoBox.h,  text : this.invoiceForm.value.invoiceNo,margin: [60, 10, 10, 0]}
      //           ],
      //           relativePosition : {x : (invoiceNoBox.x), y : -invoiceNoBox.h}
  
      //         },           
      //       ],
      //       []
      //    ]

      // },

      {
        columns : [
       
          [          
            {alignment:'left',canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
            '\n',
            {text: 'Signature of Guest', alignment: 'left', margin: [25, 5, 0, 5]},
          ],  
     
          [
            {alignment:'right',canvas: [{ margin: [0, 5, 0, 5], type: 'line', x1: 0, y1: 5, x2: 150, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
            '\n',
            {text: 'Signature of Cashier', alignment: 'right', margin: [0, 5, 20, 5]},
  
          ],    

        ]

      },

     
    

      // '\n','\n','\n',  
      // '\n','\n',

  ],  // end content

  

 
      styles: {  
        reportHeader: {  
            bold: true,  
            decoration: 'underline',  
            fontSize: 14,  
            margin: [0, 15, 0, 15],
            alignment: 'center',             
        },
        tableFont: {  
          fontSize: 10,  
           
      
        }       
    } 
      
      
     };// end 


      if(action==='open'){    
            pdfMake.createPdf(documentDefinition).open();  
          
        }else if(action === 'print'){    
            pdfMake.createPdf(documentDefinition).print();          
        }
        else if(action === 'download'){    
          pdfMake.createPdf(documentDefinition).download(`Invoice-${this.invoiceForm.value.invoiceNo}`);     
      }
    }


   transformNumberFormat(number) {
    return this.decimalPipe.transform(number,'1.2-2');
   }

    } // end class

